import _ from 'lodash'
import type {ComponentExportStructure} from '@wix/document-services-types'
import type {DecorationSingleComponentPluginFunction} from '../../types'
import {getDefaultCropMaskMapping, getFieldMapping, SCOPED_DATA, ScopedDataItem, URL_PARAM_TO_PATH} from './constants'
import {unpackFromQueryParams} from '../../utils/urlParams'
import {copyFields, moveFields} from '../../utils/mapFields'

const mapDesignItems = (component: ComponentExportStructure) => {
    const designItems = []

    if (!_.isEmpty(component.design?.default)) {
        designItems.push(component.design.default)
    }

    if (!_.isEmpty(component.design?.variants)) {
        designItems.push(...component.design.variants.map((v: {value: ScopedDataItem}) => v.value))
    }

    designItems.forEach(design => {
        moveFields(design, _.invert(SCOPED_DATA))

        if (component.displayMode) {
            design.displayMode = component.displayMode
        }

        delete design.type
    })
}

const convertDesignToScopedData = (component: ComponentExportStructure) => {
    if (!component.design) {
        component.data.scopedData = []
        return
    }

    const scopedData = []

    if (!_.isEmpty(component.design?.default)) {
        scopedData.push(component.design.default)
    }

    if (!_.isEmpty(component.design.variants)) {
        scopedData.push(
            ...component.design.variants.map((variant: {conditions: string[]; value: ScopedDataItem}) => {
                variant.value.breakpoint = variant.conditions[0]
                return variant.value
            })
        )
    }

    if (scopedData.length > 0) {
        component.data.scopedData = scopedData
    }

    delete component.design
}

export const unpack: DecorationSingleComponentPluginFunction = (component: ComponentExportStructure) => {
    // extract width and height from src to data
    component.src = unpackFromQueryParams(component, 'src', URL_PARAM_TO_PATH)
    // convert width and height to number
    _.forEach(Object.values(URL_PARAM_TO_PATH), path => {
        const value = _.get(component, path)
        if (value) {
            _.set(component, path, parseInt(value, 10))
        }
    })

    const defaultDesignPath = `design.default`

    mapDesignItems(component)
    moveFields(component, _.invert(getFieldMapping(defaultDesignPath)))
    copyFields(component, getDefaultCropMaskMapping(defaultDesignPath))
    convertDesignToScopedData(component)
}
